'use es6';

import PortalIdParser from 'PortalIdParser';
import Routes from 'ContentUtils/Routes';

/**
 * Internal routes
 */

function getFormsV2RoutePrefix() {
  const portalId = PortalIdParser.get();
  return `/forms/${portalId}`;
}
function getFormsRoutePrefix() {
  const portalId = PortalIdParser.get();
  return `/forms/${portalId}`;
}
export function getDashboardRoute() {
  return `${getFormsV2RoutePrefix()}/`;
}
export const getCompareRoute = ids => {
  const idQueryString = ids && ids.length > 0 ? `?id=${ids.join('&id=')}` : '';
  return `${getFormsV2RoutePrefix()}/compare${idQueryString}`;
};
export function getContactListsRoute(guid) {
  const portalId = PortalIdParser.get();
  const filter = {
    filterBranches: [{
      filterBranches: [],
      filterBranchOperator: 'AND',
      filterBranchType: 'AND',
      filters: [{
        filterType: 'FORM_SUBMISSION',
        formId: guid
      }]
    }],
    filterBranchOperator: 'OR',
    filterBranchType: 'OR',
    filters: []
  };
  return `/contacts/${portalId}/objectLists/create?objectTypeId=${encodeURIComponent('0-1')}&processingType=DYNAMIC&filterBranch=${encodeURIComponent(JSON.stringify(filter))}`;
}
export function isAppRoute(pathname) {
  if (!pathname) return false;
  return pathname.indexOf(getFormsRoutePrefix()) === 0 || pathname.indexOf(getFormsV2RoutePrefix()) === 0;
}

/**
 * External routes
 */

export function getFormFileUploadsRoute(guid) {
  return Routes.fileManager(`form-uploads/${guid}`);
}
export const getEmailFooterSettingsRoute = () => `/settings/${PortalIdParser.get()}/marketing/email/configuration/footer`;